const UPDATE_MARKETPLACE = 'UPDATE_MARKETPLACE';
const UPDATE_PAGE_INFO = 'UPDATE_PAGE_INFO';
const INITIAL_SYNC_PRODUCTS = 'INITIAL_SYNC_PRODUCTS';

export { UPDATE_MARKETPLACE, UPDATE_PAGE_INFO, INITIAL_SYNC_PRODUCTS };
